import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export default function useFormat() {
    const formatPhoneNumber = phoneNumberString => {
        if (!phoneNumberString) return phoneNumberString
        let cleaned = `${phoneNumberString}`.replace(/\D/g, '')
        if (cleaned.length === 11 && cleaned[0] === '8') {
            cleaned = `7${cleaned.slice(1)}`
        }
        const match = cleaned.match(/^(7|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            const intlCode = match[1] ? '+7 ' : ''
            return [
                intlCode,
                '(',
                match[2],
                ') ',
                match[3],
                '-',
                match[4],
            ].join('')
        }
        return phoneNumberString
    }

    const addDefTimeZone = strDate => {
        if (!strDate) return ''
        const date = strDate.toString()
        const result = date.match(
            /^(\d{1,2})\.(\d{2})\.(\d{4})T(\d{2}):(\d{2}):(\d{2})/
        )
        return result
            ? `${result[3]}-${result[2]}-${result[1]}T${result[4]}:${result[5]}:${result[6]}+00:00`
            : strDate
    }

    const formatDate = date => {
        if (!date) return ''
        const myDate = new Date(addDefTimeZone(date))
        if (myDate.getFullYear() === 1) return ''
        return `${myDate.toLocaleDateString(
            'ru-RU'
        )} ${myDate.toLocaleTimeString('ru-RU')}`
    }

    const isToday = someDate => {
        const today = new Date()
        return (
            someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
        )
    }

    const formatDateHuman = date => {
        if (!date) return ''
        const myDate = new Date(addDefTimeZone(date))
        if (isToday(myDate))
            return `сегодня ${myDate.toLocaleTimeString('ru-RU')}`
        return `${myDate.toLocaleDateString(
            'ru-RU'
        )} ${myDate.toLocaleTimeString('ru-RU')}`
    }

    const formatOnlyDate = (date, opts = {}) => {
        if (!date) return ''
        const myDate = new Date(date)
        return myDate.toLocaleDateString('ru-RU', opts)
    }

    const formatOnlyTime = (date, opts = {}) => {
        if (!date) return ''
        const myDate = new Date(date)
        return myDate.toLocaleTimeString('ru-RU', opts)
    }

    const formatLocaleDate = (
        date,
        {
            includeTime = false,
            dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' },
            timeOptions = { hour: '2-digit', minute: '2-digit' },
        } = {}
    ) => {
        if (!date) return ''
        const myDate = new Date(addDefTimeZone(date))
        if (Number.isNaN(myDate.getTime())) return ''

        const formattedDate = myDate.toLocaleDateString('ru-RU', dateOptions)
        if (!includeTime) return formattedDate

        const formattedTime = myDate.toLocaleTimeString('ru-RU', timeOptions)
        return `${formattedDate} ${formattedTime}`
    }
    // 11.09.2022 02:02
    const parseStringToDate = strDate => {
        if (!strDate) return null
        const result = strDate.match(
            /^(\d{1,2})\.(\d{1,2})\.(\d{4})\s(\d{1,2}):(\d{1,2})/
        )
        return new Date(
            result[3],
            result[2] - 1,
            result[1],
            result[4],
            result[5]
        )
    }
    // 12:00:00
    const parseStringTime = strTime => {
        if (!strTime) return ''

        const regex = /^(\d{1,2}):(\d{1,2}):(\d{1,2})/
        if (!regex.test(strTime)) return ''

        const result = strTime.match(regex)
        return {
            hour: result[1],
            minutes: result[2],
            seconds: result[3],
        }
    }

    const formatDateForPickr = date => {
        if (!date) return ''
        return `${date.getDate().toString().padStart(2, '0')}.${(
            date.getMonth() + 1
        )
            .toString()
            .padStart(2, '0')}.${date.getFullYear()} ${date
            .getHours()
            .toString()
            .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }

    const formatDateGQL = inpDate =>
        `${inpDate.getFullYear()}-${
            inpDate.getMonth() + 1
        }-${inpDate.getDate()}T${inpDate.getHours()}:${inpDate.getMinutes()}:${inpDate.getSeconds()}`

    const formatDateBCalendar = inpDate =>
        `${inpDate.getFullYear()}-${
            inpDate.getMonth() + 1
        }-${inpDate.getDate()}`

    const formatCountableWords = (count, words) => {
        const value = Math.abs(count) % 100
        const num = value % 10
        if (value > 10 && value < 20) return words[2]
        if (num > 1 && num < 5) return words[1]
        if (num === 1) return words[0]
        return words[2]
    }

    const formatPrice = (price, style = 'currency') => {
        if (!price && typeof price !== 'number') return ''

        switch (style) {
            case 'decimal':
                return new Intl.NumberFormat('ru-RU', {
                    style,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(price)
            case 'report':
                return new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
                    .format(price)
                    .replace(',', '.')

            default:
                return new Intl.NumberFormat('ru-RU', {
                    style,
                    currency: 'RUB',
                })
                    .format(price)
                    .replace(',', '.')
        }
    }

    const toISOStringWithTimezone = date => {
        const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
            date.getDate()
        )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
            date.getSeconds()
        )}Z`
    }

    const convertToTZformat = date => {
        return dayjs(date).format('YYYY-MM-DDTHH:mm:ssZ')
    }

    const minToHours = value => {
        if (value == null || Number.isNaN(value)) return ''

        const hours = Math.floor(value / 60)
        const mins = value % 60

        if (hours === 0 && mins === 0) return ''

        const resHours = hours ? `${hours} ч ` : ''
        const resMins = mins ? `${mins} мин` : ''

        return `${resHours}${resMins}`.trim()
    }

    // 2022-09-11 to 11.09.2022
    const convertEnToRu = en => {
        if (!en) return ''
        const array = en.split('-')
        return `${array[2]}.${array[1]}.${array[0]}`
    }

    const formatTimeLeft = (endDate, nowDate = new Date()) => {
        if (!endDate) return ''
        const now = new Date(nowDate)
        const end = new Date(endDate)
        const diff = end.getTime() - now.getTime()

        if (diff <= 0) return '00:00:00'

        const dayMs = 1000 * 60 * 60 * 24

        if (diff >= dayMs) {
            return ''
        }

        const hours = Math.floor(diff / (1000 * 60 * 60))
            .toString()
            .padStart(2, '0')
        const minutes = Math.floor((diff / (1000 * 60)) % 60)
            .toString()
            .padStart(2, '0')
        const seconds = Math.floor((diff / 1000) % 60)
            .toString()
            .padStart(2, '0')

        return `${hours}:${minutes}:${seconds}`
    }

    return {
        formatDate,
        formatPhoneNumber,
        formatOnlyDate,
        formatOnlyTime,
        parseStringToDate,
        formatDateForPickr,
        formatDateGQL,
        formatDateBCalendar,
        formatCountableWords,
        formatPrice,
        toISOStringWithTimezone,
        formatDateHuman,
        minToHours,
        convertEnToRu,
        parseStringTime,
        convertToTZformat,
        formatLocaleDate,
        formatTimeLeft,
        isToday,
    }
}

export function useIntervals() {
    const { parseStringTime } = useFormat()
    const getInterval = (strDeliveredDate, intervals) => {
        if (!strDeliveredDate || !intervals) return ''

        const deliveredDate = new Date(strDeliveredDate)
        const findedInterval = intervals.find(e => {
            const getDateWithTime = strTime => {
                const date = new Date(deliveredDate)
                const parseTime = parseStringTime(strTime)
                date.setHours(parseTime.hour)
                date.setMinutes(parseTime.minutes)
                date.setSeconds(parseTime.seconds)

                return date
            }

            const startDate = getDateWithTime(e.start_time)
            const endDate = getDateWithTime(e.end_time)

            return (
                startDate.getTime() <= deliveredDate.getTime() &&
                deliveredDate.getTime() < endDate.getTime()
            )
        })
        return findedInterval || ''
    }
    return { getInterval }
}
